/*
 * Copyright (c) 2026. Bolmate B.V.
 *
 * Generic empty-state card: a centered illustration with a title and optional
 * supporting content (subtitle, links, actions). Used wherever a list or feed
 * has nothing to show yet.
 */
import './style/bolmateEmptyState.scss';

import React, {ReactNode} from 'react';

import classNames from 'classnames';

import Image from '../../misc/image';

interface Props {
    title: ReactNode;
    /** Name of an image in res/img (resolved by the Image control). */
    image?: string;
    /** Custom node rendered in the illustration slot (e.g. a loader) when the state is not a plain image. */
    ornament?: ReactNode;
    /** Supporting content rendered below the title (subtitle, links, actions). */
    children?: ReactNode;
    className?: string;
}

export default function BolmateEmptyState(props: Props) {
    const {title, image, ornament, children, className} = props;

    return (
        <div className={classNames('bolmate-empty-state', className)}>
            {!!image && <Image name={image} className='empty-state-image' />}
            {ornament != null && <div className='empty-state-ornament'>{ornament}</div>}
            <label className='empty-state-title'>{title}</label>
            {children != null && <div className='empty-state-content'>{children}</div>}
        </div>
    );
}
